// 多語言標籤：en_US.js
import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
  ...enLocale,
  PUB: {
    lyods: 'Lyods Engineering Ltd',
    home: 'Home',
    name: 'Name',
    lang: 'Language',
    admin: 'Administrator',
    login: 'Login',
    tenantId: 'Tenant Id',
    userRole: 'User Role',
    reLogin: 'Login Again',
    logining: 'Login...',
    logout: 'Logout',
    logoutTips: 'Are you sure to exit the system?',
    loginName: 'Login Name',
    password: 'Password',
    resetPwd: 'Reset Password',
    code: 'Verification Code',
    retrieve: 'Retrieve password',
    copyright: 'all rights reserved',
    rememberMe: 'Remember me',
    fogertPwd: 'Forgot your password',
    cancelMail: 'Cancel all email',
    loading: 'Loading...',
    inputContent: 'Please Input Content',
    pleSelect: 'Please Select',
    pleMultiSelect: 'multiple values separated by ","',
    inputMultiContent: 'multiple values separated by ',
    selectDate: 'Please Select Date',
    selectTime: 'Please Select Time',
    selectDateTime: 'Please Select DateTime',
    ok: 'Ok',
    cancel: 'Cancel',
    return: 'Back',
    tips: 'Tips',
    sysTips: 'System Tips',
    person: 'Personal Center',
    layout: 'Layout Setting',
    layoutSize: 'Layout Size',
    search: 'Search',
    add: 'Add',
    upd: 'Update',
    del: 'Delete',
    view: 'View',
    copy: 'Copy',
    imp: 'Import',
    exp: 'Export',
    auth: 'Authorize',
    nonselected: 'please select record first',
    warn: 'Warning',
    confirmDelete: 'Are you sure to delete this record?',
    confirmSession: "This record is the current user. Are you sure to delete it?",
    cancelOper: 'Current operation cancelled.',
    confirmPwd: 'Confirm Password',
    email: 'Email',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    address: 'Address',
    status: 'Status',
    normal: 'Normal',
    invalid: 'Invalid',
    checkAll: 'Check All',
    field: 'Field',
    oper: 'Operator',
    searchVal: 'Search Value',
    action: 'Action',
    sort: 'Sort',
    unit: 'Unit',
    unitGrp: 'Unit Group',
    refresh: 'Refresh',
    closeOth: 'Close Others',
    closeCurr: 'Close',
    closeAll: 'Close All',
    show: 'Show',
    fixed: 'Fixed',
    open: 'Open',
    sysLayout: 'System layout configuration',
    themeColor: 'Theme Color',
    reset: 'Reset',
    oldPwd: 'Old Password',
    newPwd: 'New Password',
    sercurity: 'Security',
    download: 'Download',
    minute: 'Minute',
    hour: 'Hour',
    day: 'Day',
    month: 'Month',
    week: 'Week',
    today: 'today',
    yesterday: 'yesterday',
    aWeekAgo: 'A week ago',
    close: 'Close',
    newVal: 'New Data',
    oldVal: 'Old Data',
    label: 'Label Name',
    content: 'Content',
    chgDetails: 'Change Details',
    reloadLic: 'Reload License',
    remark: 'Remark',
    reject: 'Reject',
    color: 'Color',
    upload: 'Upload',
    uploadClick: 'Upload Click',
    uploadMax: 'Exceeded the maximum number of files uploaded',
    uploadDrag: 'Drag the file here, or',
    uploadFormatError: 'The file format is incorrect, please upload again',
    uploadImg: 'File format error, please upload image type, such as: JPG, PNG suffix file',
    uploadMaxSize: 'Upload file size exceeds limit',
    downTmpl: 'Download Template',
    xlsOrXlsx: 'Only "xls" or "xlsx" files are allowed to import!',
    removeConfirm: 'Confirm Remove',
    chgFileDown: 'Change File Download',
    Mon: 'Mon.',
    Tues: 'Tues.',
    Wed: 'Wed.',
    Thur: 'Thur.',
    Fri: 'Fri.',
    Sat: 'Sat.',
    Sun: 'Sun.',
    total: 'Show Total',
    mandatory: 'Mandatory',
    allowValue: 'Allow Value',
    txt: 'Only "txt" files is allowed to import!',
    expExcel: 'Export Excel File',
    //Camera
    noFrontCamera: "You don't seem to have a front camera on your device",
    noRearCamera: "You don't seem to have a rear camera on your device",
    startDate: 'Start Date',
    endDate: 'End Date',
    noticeUnit: 'Notice Dept',
    help: "Help",
    variable: "Variable"
  },
  http: {
    401: 'Unauthorized',
    404: 'Page not found',
    500: 'System internal error'
  },
  valid: {
    required: 'This field is required.',
    number: 'Must be a numeric value.',
    addSearch: 'Please add query criteria',
    sameSearch: 'This field already has the same condition of comparison answer. Please do not add it repeatedly',
    nonChgView: 'There is no change for the current view, not need to save!',
    selColumn: 'Select at least one column',
    addView: 'There are still have unsaved views. Do you want to add a new view?',
    saveView: 'Determine the action to save the current view?',
    selected: 'Select at least one option',
    unitGrp: 'Group and Unit at least select one of them',
    unit: 'Select at least one department',
    cpwd: 'Please enter the password again',
    ncpwd: 'The two passwords are inconsistent',
    email: 'Please enter a valid email address',
    mobile: 'Please input the correct mobile number',
    selRole: 'Role must be selected',
    rqlang: 'Dictionary language and dictionary value are required',
    dblang: 'The same dictionary language already exists',
    pwdValidError: 'Passwords must contain at last:',
    length: 'length',
    letters: 'letters',
    digits: 'degits',
    specialCharracters: 'Special characters',
    containSensitive: 'Lowercase and uppercase character',
    selMenu: 'Menu must be selected',
    formatErr: 'Wrong format',
    trueOrFalse: 'The value must be true or false',
    unPerm: 'You do not have permission to process',
    uploadFile: 'Please upload the file first',
    selUnitGrp: 'Select at least one Group',
    extEmpty: 'Please select extended function',
    extExists: 'The extended function already exists',
    extLen: 'Length must be less than',
    min: 'Minimum value:',
    max: 'Maximum value:',
    range: 'Please enter a value between {0} and {1}.'
  },
  view: {
    add: 'Add View',
    upd: 'Update View',
    del: 'Delete View',
    name: 'View Name',
    column: 'View Column',
    confirmDel: 'Confirm to delete the current view?',
    confirmDefView: 'Are you sure to set the current view as default?',
    save: 'Save View',
    share: 'Share View',
    defView: 'Default View',
    priView: 'Private View',
    priViewDes: 'Private view visible only to yourself',
    pubView: 'Public View',
    pubViewDes: 'Set this as the default public view, visible for all',
    roleView: 'Role View',
    roleViewDes: 'Select the view that the relevant role can visit below'
  },
  oper: {
    eq: 'Equal',
    ne: 'Not equal',
    starWith: 'Starts with',
    endWith: 'Ends with',
    contains: 'Contains',
    bigger: 'Greater',
    less: 'Less',
    biggerThan: 'Greater than or equal to',
    lessThan: 'Less than or equal to',
    before: 'Is before',
    after: 'Is after',
    lastDay: 'The last day',
    lastWeek: 'The last week',
    lastMonth: 'The last month',
    last3Month: 'The last 3 months',
    last6Month: 'The last 6 months',
    lastYear: 'The last year',
    no: 'Not In',
    yes: 'In',
    ltToday: 'Less today',
    leToday: 'Less or equal today',
    gtToday: 'Greater today',
    geToday: 'Greater or equal today'
  },
  role: {
    add: 'Add Role',
    upd: 'Update Role',
    view: 'View Role',
    del: 'Delete Role',
    name: 'Role Name',
    desc: 'Role Description',
    menu: 'Menu Options',
    assignRole: 'Available Roles',
    select: 'Selected Roles',
    expEncodeFile: 'Export Encoded File',
    btn: 'Batch Email Notification',
    rtn: 'Email Notification in Real-time'
  },
  user: {
    add: 'Add User',
    upd: 'Update User',
    view: 'View User',
    del: 'Delete User',
    resetinf: 'Password Updated:'
  },
  unit: {
    add: 'Add Unit',
    upd: 'Update Unit',
    view: 'View Unit',
    del: 'Delete Unit',
    code: 'Unit Code',
    desc: 'Unit Name'
  },
  codeDtl: {
    add: 'Add CodeDtl',
    upd: 'Update CodeDtl',
    view: 'View CodeDtl',
    del: 'Delete CodeDtl',
    refMasterCode: 'Main Code',
    refCode: 'Code',
    refDesc: 'Description'
  },
  unitGrp: {
    add: 'Add UnitGrp',
    upd: 'Update UnitGrp',
    view: 'View UnitGrp',
    del: 'Delete UnitGrp',
    name: 'Group name',
    desc: 'Group Description',
    exp1: 'EXP',
    assignUnitGrp: 'Optional Group',
    selectUnitGrp: 'Selected Group',
    assignUnit: 'Optional Unit',
    selectUnit: 'Selected Unit'
  },
  dic: {
    add: 'Add Dictionary',
    upd: 'Update Dictionary',
    del: 'Delete Dictionary',
    view: 'View Dictionary',
    hkey: 'Field Name',
    pkey: 'Parent Field',
    code: 'Code',
    desc: 'Description'
  },
  cron: {
    add: 'Add Task',
    upd: 'Update Task',
    del: 'Delete Task',
    view: 'View Task',
    hkey: 'Task Name',
    func: 'Function Description',
    executeTime: 'Execution Time',
    execStatus: 'Execution Status',
    concurrent: 'Allow Concurrency',
    lastExecDate: 'Last Execution Time',
    nextExecDate: 'Next Execution Time',
    lastRunResult: 'Final Execution Result',
    ap1: ', - * /',
    ap2: ', - * ? / L',
    ap3: ', - * ? / L #',
    sp1: 'Using the asterisk (*) in a field indicates that you want to include all legal values for that field. For example, using this character in the month field means to fire the trigger for every month.Example expression:0 * 17 * * ?Meaning: Fire the trigger every minute, every day starting at 5 PM until 5:59 PM.',
    sp2: 'The question mark (?) character can be used only in the day of month and day of week fields, but not at the same time. You can think of the ? character as "I don\'t care what value is in this field." This is different from the asterisk, which indicates every value for the field. The ? character says that no value was specified for this field.Example expression:0 10,44 14 ? 3 WED Meaning: Fire at 2:10 PM and 2:44 PM every Wednesday in the month of March.',
    sp3: 'The comma (,) character is used to specify a list of additional values within a given field. For example, using the value 0,15,30,45 in the second field means to fire the trigger every 15 seconds',
    sp4: 'The slash (/) character is used to schedule increments.Example expression:0/15 0/30 * * * ?Meaning: Fire the trigger every 15 seconds on the hour and half-hour.',
    sp5: 'The hyphen (-) character is used to specify a range.Example expression:0 45 3-8 ? * *Meaning: Fire the trigger on 45 past the hours 3 AM through 8 AM.',
    sp6: 'The L character represents the last allowed value for the field. It is supported by the dayofmonth and dayofweek fields only. When used in the day of month field, it represents the last day of the month for the value specified in the month field.The expression 0 0 8 L * ? means to fire the trigger at 8:00 AM the last day of every month. The * character in the month field gives us the "every month" part.',
    sp7: 'The character (#) can only be used in the day of week field. It\'s used to specify the specified day of the month. For example, if you specified the value 6#3 in the day of week field, it would mean the third Friday of the month (6 = Friday and #3 = the third one in the month). Another example of 2#1 means the first Monday of the month (2 = Monday and #1 means the first one of the month). Note that if you specify #5 and there is not 5 weeks in the month, so no firing will occur in that month.'
  },
  atlog: {
    view: 'View Audit Log',
    operTime: 'Operation Date',
    operHost: 'Operation Host',
    permission: 'Functional Module'
  },
  userInfo: {
    avatar: 'Update Avatar',
    baseData: 'Basic Information',
    updUserData: 'User Information',
    updUserPwd: 'User Password Control'
  },
  mailSuccess: {
    notice1: 'Email sent successfully',
    notice2: '　　The system has sent the password reset link to your email address',
    notice3: '.Please check in time. Reset the password and complete the operation within 24 hours.',
    notice4: "　　Haven't you received the email yet? Click [ ",
    notice5: 'retrieve password',
    notice6: ' ] to try again.'
  },
  msgTmpl: {
    add: 'Add Message Template',
    upd: 'Update Message Template',
    view: 'View Message Template',
    hdrKey: 'Template Type',
    defFlag: 'Is Default',
    tmplTitle: 'Template Title',
    tmplContent: 'Template Content'
  },
  alertMsg: {
    add: 'Add System Notification',
    del: 'Delete System Notification',
    upd: 'Update System Notification',
    view: 'View System Notification'
  },
  holiday: {
    info: 'Holiday Details',
    hdate: 'Date',
    isHoliday: 'Is Holiday',
    hdateDesc: 'Description',
    addArrange: 'Add holiday arrangements',
    updArrange: 'Update holiday arrangements',
    add: 'Add Holidays',
    upd: 'Update Holidays',
    holiday: 'Holiday',
    workingDay: 'Working Day',
    toVoid: 'Void',
    countryCode: 'Country / Region',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectMonth: 'Select Month',
    nonselected: 'Please select country / region code or date range first',
    weekend: 'Weekend'
  },
  userLogin: {
    add: 'Add User Login Control',
    upd: 'Update User Login Control',
    view: 'View User Login Control',
    byDay: 'Daily',
    byWeekend: 'Weekly',
    nonselected: 'Please select the cycle',
  },
  mclient: {
    add: 'Add Client',
    upd: 'Update Client',
    view: 'View Client',
    lyodsVersion: 'Version',
    onlyKey: 'Only "key" files are allowed to import!',
    company: 'Company',
    site: 'City',
    project: 'Project Name',
    platform: 'Operating System',
    func: 'Function Module',
    maxUser: 'Max Online Users',
    expiration: 'Expiration',
    licInfo: 'License Information',
    logo: 'Client Logo',
    sysInfo: 'System Information',
    updSysInfo: 'System Information Maintenance'
  },
  apiKeys: {
    add: 'Add API Key',
    del: 'Delete  API Key',
    upd: 'Update API Key',
    view: 'View API Key',
    create: 'Create UUID',
    illegalChar: 'Special characters is not allowed',
  },
  decStates: {
    add: 'Add States',
    upd: 'Update States',
    del: 'Delete States',
    view: 'View States'
  },
  project: {
    add: 'Add Project Info',
    upd: 'Update Project Info',
    del: 'Delete Project Info',
    view: 'View Project Info',
    inputNative: "Please input Chinese content",
    inputEn: "Please input English content",
    contentNative: 'Chinese Content',
    contentEn: 'English Content',
    minAmt: 'Min Amt',
    donateTypeDic: 'Donate Type Dic',
    ticketFlag: 'Ticket Flag',
    donateTypeFlag: 'Donate Type Flag',
    maxTicket: 'Max Tickets',
    briefForm: 'Brief Form',
    dinfoExtExist: 'This item has been referenced in the donation record, and the cancellation of the ticket and display support method will delete part of the corresponding donation record data',
    workshop: 'Seminar',
  },
  donate: {
    add: 'Add Record',
    upd: 'Update Record',
    view: 'View Record',
    pjId: 'Donation Project',
    nameEn: 'English Name',
    nameNative: 'Chinese Name',
    alias: 'Alias',
    gender: 'Gender',
    telephone: 'Telephone',
    mobile: 'Mobile',
    email: 'Email',
    address: 'Mailing Address',
    dnMethods: 'Donation Method',
    currency: 'Currency',
    amount: 'Amount',
    valDate: 'Donate Date',
    status: 'Status',
    refNo: 'Reference No',
    submitIp: 'IP Address',
    referrer: 'Referrer',
    certificate: 'Donate Receipt.',
    confirm: 'Confirm',
    repeat: 'Repeat',
    invalid: 'Invalid',
    refNoNoNull: 'The bank reference number is required when confirming',
    donateType: 'Donate Type',
    ticketType: 'Ticket Type',
    ticketSeq: 'Ticket No.',
    ticketCode: 'Ticket QRCode',
    ticketCheckin: 'The ticket has Check-in',
    ticketChkchop: 'Check-in Time & User'
  },
  uheart: {
    selLang: 'Language',
    project: 'Project',
    register: 'Donation Registration',
    recentDonates: 'Recent Donation Records',
    statistics: 'Donation Statistics',
    info: 'Donation Information',
    formTitle: 'Donation Form',
    formTitle1: 'Donation Projects',
    formTitle2: 'Donor/Corp. Info.',
    formTitle3: 'Donation Methods',
    formSubtitle: 'I am registering my donation',
    dnMethods: 'Direct Bank-in/ATM Transfer',
    upload: 'Upload Receipt',
    uploadTips: 'Only JPG / PNG files can be uploaded',
    uploadFormatErr: 'Upload file can only be in picture format!',
    uploadRequired: 'Payment receipt must be uploaded',
    submit: 'Submit',
    allEvents: 'All Events',
    note: 'Notes on the donation process:',
    tips: 'Your donation is valid only after confirmation by the Council. If have any questions, we will contact you by phone or email.',
    refTaxTips: 'Donations of HK$100 or above will receive a receipt for tax deduction purposes. The name of the receipt must be filled in the full name according to ID or Passport. If you need a receipt, please fill in the email.',
    point: 'Contact Point',
    phone: 'Contact Phone',
    email: 'Contact Email',
    events: 'Attend Events',
    title: 'Seminar Registration',
    capture: 'Capture',
    onsite: 'Onsite',
    webinar: 'Webinar',
    leftTicket: 'Remaining Tickets',
    send: 'Send',
    ticketType: 'Participation',
  },
  ticket: {
    check: 'Check',
    total: 'Ticket total number',
    startDate: 'Start Date',
    checkCount: 'Checked number',
    uncheckCount: 'Uncheck number',
    history: 'Check-in History',
    qrCode: 'QRCode',
    welcome: 'welcome！',
    invalid: 'Incorrect format for QRCode',
    view: 'View Ticket Check-in'
  },
  emailLog: {
    view: 'View Email Log',
  },
}

export default en



// WEBPACK FOOTER //
// ./src/assets/lang/en_US.js